import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Email({ member }) {
  return (

    <ValueItem
      icon="email-icon"
      label="Email"
    >
      {member.email}
    </ValueItem>
  );
}

Email.propTypes = {
  member: PropTypes.object.isRequired,
};
